/** Canonical slugs for character authentication routes.
 *
 * This client-safe module is the single source of truth for auth paths. The
 * guide CTA resolver reuses it so its seasonal query-string exceptions are the
 * only guide-specific routing data it owns.
 */

export const CHARACTER_AUTH_SLUGS = {
  santa: 'auth',
  reyes: 'auth-reyes',
  hada: 'auth-hada',
  'raton-perez': 'auth-raton-perez',
  generic: 'auth-mundo-magico',
} as const

export type CharacterAuthVariant = keyof typeof CHARACTER_AUTH_SLUGS

export function getCharacterAuthPath(variant: CharacterAuthVariant): string {
  return `/${CHARACTER_AUTH_SLUGS[variant]}`
}
